<!-- MFITTで指定した時刻の列車が見つからなかった場合 -->
<template>
  <ItemDialog ref="notFoundCars" image-type="alert">
    <template #content-area>
      <h2>該当の列車がありません</h2>
      <p class="text-center">条件を変更してお試しください。</p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogNotFoundCars",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const notFoundCars = ref(null);

    const openDialog = () => {
      notFoundCars.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        notFoundCars.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      notFoundCars,
      openDialog,
      closeDialog,
    };
  },
};
</script>
